<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <div class="form-group row">
            <div class="col-md-6">
                <div class="input-group">
                    <select class="form-control col-md-3" v-model="criterio">
                        <option value="email">Correo</option>
                        <option value="name">Nombre</option>
                        <option value="status">Estado</option>
                    </select>
                    <input
                        type="text"
                        v-model="search"
                        @keyup.enter="getListModel()"
                        class="form-control"
                        placeholder="Texto a buscar"
                    />
                    <button
                        type="button"
                        @click="getListModel()"
                        class="btn btn-primary"
                    >
                        <em class="fa fa-search"></em> Buscar
                    </button>
                </div>
            </div>
        </div>
        <table
            v-if="arrayModel.length > 0"
            class="table table-bordered table-striped table-sm mt-5"
        >
            <thead>
                <tr>
                    <th>Opciones</th>
                    <th>Correo</th>
                    <th>Nombre</th>
                    <th>Estado</th>
                    <th>I.P</th>
                    <th>Fecha</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="model in arrayModel" :key="model.id">
                    <td>
                        <button
                            v-tooltip.bottom-start="'Editar'"
                            type="button"
                            @click="changeView(model.id)"
                            class="btn btn-warning btn-sm"
                        >
                            <em class="fa fa-edit"></em>
                        </button>
                    </td>
                    <td v-text="model.email"></td>
                    <td v-text="model.name"></td>
                    <td v-text="model.status"></td>
                    <td v-text="model.ip"></td>
                    <td v-text="filterDate(model.created_at)"></td>
                </tr>
            </tbody>
        </table>
        <nav>
            <ul class="pagination">
                <li class="page-item" v-if="pagination.current_page > 1">
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page - 1)"
                        >Ant</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="page in pagesNumber"
                    :key="page"
                    :class="[page == isActived ? 'active' : '']"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(page)"
                        v-text="page"
                    ></a>
                </li>
                <li
                    class="page-item"
                    v-if="pagination.current_page < pagination.last_page"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page + 1)"
                        >Sig</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            arrayModel: [],
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            criterio: "name",
            search: "",
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getListModel(page);
        },
        getListModel(page = 1) {
            let me = this;
            let criterio = me.criterio;
            let search = me.search;
            axios
                .get(
                    "/api/doubts?page=" +
                        page +
                        "&criterio=" +
                        criterio +
                        "&search=" +
                        search
                )
                .then(function (response) {
                    me.arrayModel = response.data.models.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
        filterDate(value) {
            return moment(String(value)).format("DD/MM/YYYY hh:mm");
        },
        changeView(id) {
            this.$emit("change", id);
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        this.getListModel();
    },
};
</script>
